export enum RestaurantDetailsImageType {
  LOGO = 'LOGO',
  LOGO_DARK = 'LOGO_DARK',
  AVATAR = 'AVATAR'
}
